"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _team = require("../views/team");
var _activity = _interopRequireDefault(require("../views/activity"));
var _activityList = _interopRequireDefault(require("../views/activity-list"));
var _event = _interopRequireDefault(require("../views/event"));
var _infoAz = _interopRequireDefault(require("../views/info-az"));
var _detail = _interopRequireDefault(require("../views/info-az/detail"));
var _infrastructure = _interopRequireDefault(require("../views/infrastructure"));
var _providerInfrastructure = _interopRequireDefault(require("../views/provider-infrastructure"));
var _menu = _interopRequireDefault(require("../views/menu"));
var _search = _interopRequireDefault(require("../views/search"));
var _standard = _interopRequireDefault(require("../views/standard"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const parseLayout = layoutTag => {
  switch (layoutTag) {
    case "standard":
      return /*#__PURE__*/_react.default.createElement(_standard.default, {
        socialMedia: true
      });
    default:
      return /*#__PURE__*/_react.default.createElement(_standard.default, null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Switch, null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
        path: "/:lang/activity/:pagename",
        component: _activity.default,
        exact: true
      }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
        path: "/:lang/infrastructure/:pagename",
        component: _infrastructure.default,
        exact: true
      }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
        path: "/:lang/provider-infrastructure/:id?",
        component: _providerInfrastructure.default,
        exact: true
      }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
        path: "/:lang/event/:pagename",
        component: _event.default,
        exact: true
      }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
        path: "/:lang/cuisine/:id?",
        component: _menu.default,
        exact: true
      }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
        path: "/:lang/info-az/:mode/:id?",
        component: _detail.default,
        exact: true
      }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
        path: "/:lang/info-az",
        component: _infoAz.default,
        exact: true
      }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
        path: "/:lang/team/department/:id/",
        component: _team.LayoutDepartment,
        exact: true
      }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
        path: "/:lang/team/:pagename",
        component: _team.LayoutEmployee,
        exact: true
      }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
        path: "/:lang/activities/:id?/:page?",
        component: _activityList.default
      }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
        path: "/:lang/search/:query/:page?",
        component: _search.default
      }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Redirect, {
        exact: true,
        from: "/:lang/info/:id?",
        to: "/:lang/info-az/detail/:id?"
      })));
  }
};
var _default = exports.default = parseLayout;